import { FC, Fragment } from 'react'
import { List, Grid, Divider } from '@mui/material'
import { ItemEntryDetail, SlipData } from '../../../services/slips'
import { TabsEnums } from '../../../components'
import { LeftListItemComponent } from './LeftListItemComponent'
import { Bill } from 'src/services'

interface LeftItemComponentProps {
  data: ItemEntryDetail[]
  separatorHeight: number
  showOnlyBalanceItems: boolean
  account?: Bill,
  slipResponse: SlipData
}

export const LeftItemComponent: FC<LeftItemComponentProps> = ({
  slipResponse,
  data,
  separatorHeight,
  showOnlyBalanceItems,
  account,
}) => {
  return (
    <>
      {data && data.length > 0 && (
        <>
          <Divider />
          <Grid
            id="properties_name"
            container
            spacing={0}
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              minHeight: '4vh',
              pl: 2,
              pr: 2,
              backgroundColor: '#f9f9f9',
              fontWeight: 'bold',
              position: 'sticky',
              top: 0,
              zIndex: 997,
            }}
          >
            <Grid xs={2.5} sx={{ pl: 4 }}>
              Item Name
            </Grid>
            <Grid xs={2} sx={{ textAlign: 'right', pr: 2 }}>{account?.accountType === 'ITEMS_TAKEN' ? 'Hired' : 'Issue'}</Grid>
            <Grid xs={2} sx={{ textAlign: 'right', pr: 2 }}>{account?.accountType === 'ITEMS_TAKEN' ? 'Returned' : 'Received'}</Grid>
            <Grid xs={1.5} sx={{ textAlign: 'right', pr: 2 }}>Lost</Grid>
            <Grid xs={2} sx={{ textAlign: 'right', pr: 2 }}>
              Balance
            </Grid>
            <Grid xs={2} sx={{ textAlign: 'right', pr: 2 }}>
              Weight
            </Grid>
          </Grid>
          {data &&
            data.map((items, index) => {
              return (
                <List
                  id="entries_list_items_per_date"
                  sx={{
                    width: '100%',
                    p: 0,
                    m: 0,
                  }}
                  component="div"
                  aria-labelledby="subheader"
                  key={index}
                >
                  {items.itemEntries &&
                    items.itemEntries.map((item, i) => {
                    if(!showOnlyBalanceItems || item.quantity > 0) {
                      return (
                        <Fragment key={i}>
                          <Divider />
                          <LeftListItemComponent
                            item={item}
                            key={i}
                            componentName={TabsEnums.Left}
                            bgcolor={item.id < 0 ? '#e0e0e0' : 'white'}
                            accountType={account?.accountType}
                            totalWeight={slipResponse.totalWeight}
                          />
                        </Fragment>
                      )
                    }
                    })}
                </List>
              )
            })}
        </>
      )}
    </>
  )
}
